import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import { areas } from 'constants/areas';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { useReactiveVar } from '@apollo/client';
import { userGroupNameVar } from '../variables';
import { ADMIN_USER_GROUPS_READ } from 'constants/rightsCodes';
import UserGroupGeneralDataContainer from './generalData/UserGroupGeneralDataContainer';
import UsersContainer from './users/UsersContainer';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const userGroupId = match.params.id && getInt(match.params.id);
  const { t } = useTranslation();
  const userGroupName = useReactiveVar(userGroupNameVar);

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/userGroups/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>{`${t('UserGroups.Title')}:${
          userGroupName ? ` ${userGroupName}` : ' - / -'
        }`}</Typography>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton tooltip={t('Tooltips.UserGroups.BackToList')} color='transparent' onClick={() => historyContext.push(`/userGroups`)}>
          <ArrowBack />
        </IconButton>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_USER_GROUPS_READ}>
        <UserGroupGeneralDataContainer userGroupId={userGroupId} onRedirect={onRedirect} />
        {userGroupId && <UsersContainer userGroupId={userGroupId} />}
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
